import {
  NONAUTHENTICATED_DECLARATIONS,
  NONAUTHENTICATED_ENTRY_COMPONENTS,
  NONAUTHENTICATED_IMPORTS,
} from './nonauthenticated/nonauthenticated.imports';

import {
  AUTHENTICATED_DECLARATIONS,
  AUTHENTICATED_ENTRY_COMPONENTS,
} from './authenticated/authenticated.imports';
import {
  RETREVA_MINIMAL_DECLARATIONS,
  RETREVA_MINIMAL_ENTRY_COMPONENTS,
  RETREVA_MINIMAL_IMPORTS,
} from './retreva-minimal/retreva-minimal.imports';

export const LAYOUT_ENTRY_COMPONENTS = [
  ...NONAUTHENTICATED_ENTRY_COMPONENTS,
  ...AUTHENTICATED_ENTRY_COMPONENTS,
  ...RETREVA_MINIMAL_ENTRY_COMPONENTS,
];

export const LAYOUT_DECLARATIONS = [
  ...NONAUTHENTICATED_DECLARATIONS,
  ...AUTHENTICATED_DECLARATIONS,
  ...RETREVA_MINIMAL_DECLARATIONS,
];

export const LAYOUT_IMPORTS = [
  ...NONAUTHENTICATED_IMPORTS,
  ...RETREVA_MINIMAL_IMPORTS,
];
